import { HTMLAttributes, useState } from 'react';
import PolicyPauseDayInfoView from '@/dashboard/components/Products/policyCard/dialogs/pausePolicy/policyPauseDayInfo';
import LogoLoading from '@/dashboard/components/loading/LogoLoading';
import PolicyModel from '@/dashboard/models/policys/PolicyModel';
import { Divider } from '@/dashboard/mui';
import {
  ChevronDownIcon,
  ChevronUpIcon,
  PauseIcon,
} from '@heroicons/react/outline';
import {
  apiGetPausingPolicySummary,
  formatCommonDateStr,
} from '@jove-frontend/uikit';
import { Box, Button, Typography } from '@mui/material';
import clsx from 'clsx';
import TimeInfoView from './timeInfo';

type PendingSummaryViewProps = HTMLAttributes<HTMLDivElement> & {
  policy: PolicyModel;
};

const PendingSummaryView = (props: PendingSummaryViewProps) => {
  const { policy, className } = props;
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [summaryInfo, setSummaryInfo] = useState<any>({});

  /**
   * request
   */
  const requestSummaryInfo = async () => {
    setLoading(true);
    const [res] = await apiGetPausingPolicySummary({ policy_id: policy.id });
    setLoading(false);

    if (res) {
      setOpen(true);
      res.future = (res.future || []).map((item) => {
        if (item.pause_start_date)
          item.dateStr = `${formatCommonDateStr(
            item.pause_start_date
          )} - ${formatCommonDateStr(item.pause_end_date)}`;
        return item;
      });
      res.past = (res.past || []).map((item) => {
        if (item.pause_start_date)
          item.dateStr = `${formatCommonDateStr(
            item.pause_start_date
          )} - ${formatCommonDateStr(item.pause_end_date)}`;
        return item;
      });
      if (res.current && res.current.pause_start_date) {
        res.current.dateStr = `${formatCommonDateStr(
          res.current.pause_start_date
        )} - ${formatCommonDateStr(res.current.pause_end_date)}`;
      }
      res.current = res.current ? [res.current] : [];
      setSummaryInfo(res);
    }
  };

  return (
    <Box
      className={clsx(
        'relative flex flex-col rounded-lg border border-black/10',
        className
      )}
    >
      <Box className="flex h-[52px] flex-row items-center pl-4">
        <PauseIcon className="w-6" />
        <Typography className="ml-2 flex flex-1 font-bold" variant="subtitle1">
          Pausing summary
        </Typography>
        <Button>
          {open ? (
            <ChevronUpIcon
              className="h-6 w-6 text-[#999]"
              onClick={() => setOpen(false)}
            />
          ) : (
            <ChevronDownIcon
              className="h-6 w-6 text-[#999]"
              onClick={requestSummaryInfo}
            />
          )}
        </Button>
      </Box>
      {open && (
        <>
          <Divider />
          <PolicyPauseDayInfoView
            type={2}
            className="px-4 pt-4"
            info={summaryInfo?.overview}
          />
          <Divider />
          {summaryInfo?.current && summaryInfo.current.length > 0 && (
            <>
              <TimeInfoView
                policy={policy}
                title="Current period"
                list={summaryInfo?.current}
              />
              <Divider />
            </>
          )}
          {summaryInfo?.future && summaryInfo.future.length > 0 && (
            <>
              <TimeInfoView
                policy={policy}
                title="Future periods"
                list={summaryInfo?.future}
              />
              <Divider />
            </>
          )}
          {summaryInfo?.past && summaryInfo.past.length > 0 && (
            <TimeInfoView
              policy={policy}
              title="Past periods"
              list={summaryInfo?.past}
            />
          )}
        </>
      )}
      {loading && <LogoLoading />}
    </Box>
  );
};

export default PendingSummaryView;
